export const gallery = [
  {
    image: '/launchpad/stories/good-crypto-x/gallery/dex-trading.png',
    alt: 'unlock the future of DEX trading',
  },
  {
    image: '/launchpad/stories/good-crypto-x/gallery/trading-bots.png',
    alt: 'ultimate DEX trading bots',
  },
];

export const tokenMetricsGallery = [
  {
    image: '/launchpad/stories/good-crypto-x/gallery/token-metrics-one.png',
  },
  {
    image: '/launchpad/stories/good-crypto-x/gallery/token-metrics-two.png',
  },
];

export const keyFeatures = [
  {
    id: 'trading-bot',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Non-Custodial DEX Trading Bot:&nbsp;</span>
        Advanced trading features like limit and trailing orders, copy trading, and various bots
        while maintaining full control over funds.
      </span>
    ),
  },
  {
    id: 'ai-assistant',
    item: (
      <span className="font-normal">
        <span className="font-semibold">AI-Powered Assistant:&nbsp;</span>
        Simplifies trading by enabling users to execute complex trades through natural language
        commands.
      </span>
    ),
  },
  {
    id: 'smart-contract',
    item: (
      <span className="font-normal">
        <span className="font-semibold">MPC-Protected Smart Contract Wallet:&nbsp;</span>
        Ensures security with on-chain permissions and allows paying gas fees with any token.
      </span>
    ),
  },
  {
    id: 'cross-chain-support',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Cross-Chain Support:&nbsp;</span>
        Trading on Ethereum, BNB Smart Chain, Base, Arbitrum, with Solana coming soon.
      </span>
    ),
  },
  {
    id: 'comprehensive-trading-terminal',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Comprehensive CEX Trading Terminal:&nbsp;</span>
        Supports 35 centralized exchanges, offering advanced orders, automated bots, and TradingView
        webhooks.
      </span>
    ),
  },
];

export const tractions = [
  {
    id: 'user-base',
    item: (
      <span className="font-normal">
        <span className="font-semibold">User Base:&nbsp;</span>
        Over 200,000 registered users.
      </span>
    ),
  },
  {
    id: 'traded-volume',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Traded Volume:&nbsp;</span>
        Over $3 billion traded via the platform.
      </span>
    ),
  },
  {
    id: 'community',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Community:&nbsp;</span>
        120k Twitter followers, 95k Telegram members.
      </span>
    ),
  },
];

export const revenues = [
  {
    id: 'dex-swap-fees',
    item: (
      <span className="font-normal">
        <span className="font-semibold">DEX Swap Fees:&nbsp;</span>
        1% fee on all DEX swaps, with 50% distributed to $GOOD holders.
      </span>
    ),
  },
  {
    id: 'paind-subscriptions',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Paid Subscriptions:&nbsp;</span>
        Advanced CEX trading tools and DEX benefits, with 10% of subscription revenue used to buy
        and burn $GOOD tokens.
      </span>
    ),
  },
  {
    id: 'cex-commission-sharing',
    item: (
      <span className="font-normal">
        <span className="font-semibold">CEX Commission Sharing:&nbsp;</span>
        Revenue from 30-50% trading fees on partner exchanges like Binance, Bybit, OKX, and KuCoin,
        with 10% allocated to buy and burn $GOOD tokens.
      </span>
    ),
  },
];

export const investors = [
  {
    name: 'Bit Mart',
    image: '/launchpad/stories/good-crypto-x/investors/bitmart.png',
    width: 234,
    height: 67,
    className: 'py-2',
  },
  {
    name: 'GSR',
    image: '/launchpad/stories/good-crypto-x/investors/gsr.png',
    width: 117,
    height: 35,
    className: 'py-3',
  },
  {
    name: 'Cointelegraph',
    image: '/launchpad/stories/good-crypto-x/investors/cointelegraph.png',
    width: 174,
    height: 41,
    className: 'py-3',
  },
  {
    name: 'Fenbushi Capital',
    image: '/launchpad/stories/good-crypto-x/investors/fenbushi-capital.png',
    width: 190,
    height: 40,
    className: 'py-4',
  },
];

export const partners = [
  {
    name: 'PancakeSwap',
    image: '/launchpad/stories/good-crypto-x/partners/pancake-swap.png',
    width: 177,
    height: 27,
    className: 'p-4',
  },
  {
    name: 'Binance',
    image: '/launchpad/stories/good-crypto-x/partners/binance.png',
    width: 149,
    height: 30,
    className: 'p-3',
  },
  {
    name: 'Bybit',
    image: '/launchpad/stories/good-crypto-x/partners/bybit.png',
    width: 87,
    height: 34,
    className: 'p-4',
  },
  {
    name: 'Kucoin',
    image: '/launchpad/stories/good-crypto-x/partners/kucoin.png',
    width: 133,
    height: 31,
    className: 'p-4',
  },
];

export const subPartners = [
  {
    name: 'OKX',
    image: '/launchpad/stories/good-crypto-x/partners/okx.png',
    width: 133,
    height: 42,
    className: 'p-4',
  },
  {
    name: 'UniSwap',
    image: '/launchpad/stories/good-crypto-x/partners/uniswap.png',
    width: 195,
    height: 48,
    className: 'p-3',
  },
  {
    name: 'web3auth',
    image: '/launchpad/stories/good-crypto-x/partners/web3auth.png',
    width: 169,
    height: 32,
    className: 'p-4',
  },
];

export const otherPartners = [
  {
    name: 'Huobi',
    image: '/launchpad/stories/good-crypto-x/partners/huobi.png',
    width: 100,
    height: 31,
    className: 'p-4',
  },
  {
    name: 'ZeroDev',
    image: '/launchpad/stories/good-crypto-x/partners/zerodev.png',
    width: 175,
    height: 46,
    className: 'p-3',
  },
  {
    name: 'Cointelegraph',
    image: '/launchpad/stories/good-crypto-x/investors/cointelegraph.png',
    width: 174,
    height: 41,
    className: 'py-3',
  },
];

export const tokenUtility = [
  {
    id: 'revenue-sharing',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Revenue Sharing:&nbsp;</span>
        50% of DEX swap fees shared with $GOOD holders.
      </span>
    ),
  },
  {
    id: 'trade-mining',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Trade Mining:&nbsp;</span>
        Earn $GOOD tokens through platform trading.
      </span>
    ),
  },
  {
    id: 'discounts',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Discounts:&nbsp;</span>
        DEX swap fee discounts up to 50% for $GOOD holders.
      </span>
    ),
  },
  {
    id: 'governance',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Governance:&nbsp;</span>
        Influence key decisions through voting.
      </span>
    ),
  },
  {
    id: 'token-burn',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Token Burn:&nbsp;</span>
        10% of platform revenue used for token buyback and burn.
      </span>
    ),
  },
];

export const teamMembers = [
  {
    id: 'maksim-hramadtsou',
    fullName: 'Maksim Hramadtsou',
    about: (
      <ul className="ml-5 list-disc max-sm:text-sm">
        <li>
          Creator of goodcrypto, former CEO of a $0.5B real estate company, and Columbia Business
          School MBA.
        </li>
      </ul>
    ),
    width: 104,
    height: 104,
    position: 'Founder, Head of Product',
    avatar: '/launchpad/stories/good-crypto-x/team/maksim.png',
  },
  {
    id: 'alexander-evsenev',
    fullName: 'Alexander Evsenev',
    about: (
      <ul className="ml-5 list-disc max-sm:text-sm">
        <li>
          20+ years in engineering, expert in ultra-low latency HFT platforms, CTO of goodcrypto.
        </li>
      </ul>
    ),
    width: 104,
    height: 104,
    position: 'CTO, System Architect',
    avatar: '/launchpad/stories/good-crypto-x/team/alexander.png',
  },
  {
    id: 'gleb-myrko',
    fullName: 'Gleb Myrko',
    about: (
      <ul className="ml-5 list-disc max-sm:text-sm">
        <li>Co-founder of a leading web3 marketing agency, expert in SEO and digital marketing.</li>
      </ul>
    ),
    width: 104,
    height: 104,
    position: 'CMO, Head of Growth',
    avatar: '/launchpad/stories/good-crypto-x/team/gleb.png',
  },
];
